/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';

import SelectDetailedRiskAnalysis from '../../../../risk-analysis/src/components/input/SelectDetailedInputComponent';
import LinkInputRiskAnalysis from '../../../../risk-analysis/src/components/input/LinkInputComponent';
import MultiSelectRiskAnalysis from '../../../../risk-analysis/src/components/input/MultiSelectInputComponent';
import AmountInputComponentRiskAnalysis from '../../../../risk-analysis/src/components/input/AmountInputComponent';
import { Inputs } from '../../types/Enums';
import { InputProps } from './InputList';
import advisoryFlowInputComponents from './AdvisoryFlowInputComponents';

const riskAnalysisComponents = {
  ...advisoryFlowInputComponents,
  [Inputs.MULTISELECT]: (props: InputProps) => (
    <MultiSelectRiskAnalysis {...props} />
  ),
  [Inputs.MULTISELECT_DETAILED]: (props: InputProps) => (
    <MultiSelectRiskAnalysis {...props} />
  ),
  [Inputs.SELECT_DETAILED]: (props: InputProps) => (
    <SelectDetailedRiskAnalysis {...props} />
  ),
  [Inputs.LINK]: (props: InputProps) => <LinkInputRiskAnalysis {...props} />,
  [Inputs.AMOUNT]: (props: InputProps) => (
    <AmountInputComponentRiskAnalysis {...props} />
  ),
  [Inputs.ROOM]: (props: InputProps) => (
    <AmountInputComponentRiskAnalysis {...props} />
  ),
};

export default riskAnalysisComponents;
